// أدوات مساعدة للعجلات والمواسم (منطق زمني نقي، لا يعتمد على مصدر البيانات).

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * يحوّل حقل الصورة الوارد من الـAPI إلى URL صالح للعرض:
 * - "/api/images/xxx" → REACT_APP_BACKEND_URL + المسار
 * - "https://..." → كما هو (روابط خارجية موروثة)
 * - null/فارغ → null
 */
export const resolveImageUrl = (image) => {
  if (!image) return null;
  if (image.startsWith("/")) return `${BACKEND_URL}${image}`;
  return image;
};

/**
 * يحدد حالة العجلة: 'upcoming' | 'live' | 'ended'
 * إذا كان startsAt = null نعتبرها متوفرة (live) ما لم تنته.
 */
export const getEventStatus = (event, now = Date.now()) => {
  if (!event?.endsAt) {
    if (event?.startsAt && now < new Date(event.startsAt).getTime()) return "upcoming";
    return "live";
  }
  const end = new Date(event.endsAt).getTime();
  if (now > end) return "ended";
  if (!event.startsAt) return "live";
  const start = new Date(event.startsAt).getTime();
  if (now < start) return "upcoming";
  return "live";
};

export const STATUS_LABELS = {
  upcoming: "قادمة",
  live: "متوفرة الآن",
  ended: "انتهت",
};

/**
 * الترتيب:
 * - live أولاً (حسب أقرب نهاية).
 * - upcoming ثم (حسب أقرب بداية).
 * - ended أخيرًا (الأحدث انتهاءً أولًا، مع تفضيل featured).
 */
export const sortEvents = (events, now = Date.now()) => {
  const priority = { live: 0, upcoming: 1, ended: 2 };
  return [...events].sort((a, b) => {
    const sA = getEventStatus(a, now);
    const sB = getEventStatus(b, now);
    if (sA !== sB) return priority[sA] - priority[sB];
    if (sA === "upcoming") {
      return new Date(a.startsAt) - new Date(b.startsAt);
    }
    if (sA === "live") {
      if (!a.endsAt || !b.endsAt) return a.endsAt ? -1 : b.endsAt ? 1 : 0;
      return new Date(a.endsAt) - new Date(b.endsAt);
    }
    if (a.featured !== b.featured) return a.featured ? -1 : 1;
    return new Date(b.endsAt) - new Date(a.endsAt);
  });
};

/**
 * الحالة لموسم كود موبايل.
 */
export const getSeasonStatus = (season, now = Date.now()) => {
  const start = new Date(season.startAt).getTime();
  const end = new Date(season.endAt).getTime();
  if (now < start) return "upcoming";
  if (now < end) return "live";
  return "ended";
};
